<template>
  <div class="page project-list-container">
    <LayoutContainer>
      <div class="project-list-empty section">
        <p class="description">ยังไม่มีโปรเจต์</p>
        <h1 class="title">กรุณาสร้างโปรเจกต์เพื่อเริ่มใช้งาน</h1>
        <router-link :to="`/${teamName}/projects/create`" class="action">
          <Button :buttonClass="'btn-primary'">สร้างโปรเจกต์</Button>
        </router-link>
      </div>
    </LayoutContainer>
  </div>
</template>

<script>
import Button from '@/form/Button.vue';
import LayoutContainer from '@/layout/LayoutContainer.vue';

export default {
  components: {
    Button,
    LayoutContainer,
  },
  computed: {
    teamName() {
      return this.$route.params.teamName;
    },
  },
  data() {
    return {
      projects: null,
      state: {
        isLoading: false,
      },
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';
@import '@/assets/scss/themes/components/section.scss';
@import '@/assets/scss/themes/components/list.scss';

.project-list-container {
  padding-bottom: $spacer * 2;
}

.project-list-empty {
  height: 300px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .description {
    margin-bottom: $spacer * 0.5;
  }

  .title {
    color: $body-color;
    font-size: $font-size-base * 1.5;
  }
}

</style>
